import '../styles/loading.css'

interface LoadingProps {
  message?: string
}

export function Loading({ message = 'Loading...' }: LoadingProps) {
  return (
    <div className="loading-container" role="status" aria-label={message}>
      <div className="loading-spinner" />
      <p className="loading-message">{message}</p>
    </div>
  )
}
